import { coreAxios } from "utilities/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

const BASE_URL = process.env.REACT_APP_MAIN_URL


export const GetWorkOrderListByShop = createAsyncThunk(
  "workorder/GetWorkOrderListByShop",
  async (id) => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/work/order/list/${id}`);
    return data
  }
);

export const AddWorkOrder = createAsyncThunk(
  "workorder/AddWorkOrder",
  async (data) => {
    const response = await coreAxios.post(`${BASE_URL}/api/work/order/create/`, data)
    return response.data
  }
); 

export const UpdateWorkOrder = createAsyncThunk(
  "workorder/UpdateWorkOrder",
  async (data) => {
    const response = await coreAxios.put(`${BASE_URL}/api/work/order/update/${data.id}/`, data)
    return response.data
  }
);


export const GetWorkOrderItems = createAsyncThunk(
  "workorder/GetWorkOrderItems",
  async (id) => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/work/order/item/list/${id}/`)
    return data
  }
);

export const DeleteWorkOrder = createAsyncThunk(
  "workorder/DeleteWorkOrder",
  async (id) => {
    const response = await coreAxios.delete(`${BASE_URL}/api/work/order/delete/${id}/`)
    return response.status
  }
);

export const GetWorkOrderItemsForChalan = createAsyncThunk(
  "workorder/GetWorkOrderItemsForChalan",
  async (id) => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/work/order/item/list/for/chalan/${id}/`)
    return data
  }
);

export const GetWorkOrderDetail = createAsyncThunk(
  "workorder/GetWorkOrderDetail",
  async (id) => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/work/order/detail/${id}/`)
    return data
  }
);
